import { differenceInCalendarWeeks, isSameWeek, startOfWeek } from 'date-fns';
import { tenantToday } from '@utils/timeZone';

export const getPrefix = (date: Date): string => {
  const today = tenantToday();
  const isNextWeek = differenceInCalendarWeeks(date, startOfWeek(today)) === 1;
  const isPreviousWeek = differenceInCalendarWeeks(date, startOfWeek(today)) === -1;
  if (isSameWeek(date, today)) return 'pages.workload.thisWeek';
  if (isNextWeek) return 'pages.workload.nextWeek';
  if (isPreviousWeek) return 'pages.workload.previousWeek';
  return '';
};
